import { render, staticRenderFns } from "./DataTableCandidate.vue?vue&type=template&id=61210cb8"
import script from "./DataTableCandidate.vue?vue&type=script&lang=js"
export * from "./DataTableCandidate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports